module.exports = __webpack_public_path__ + "img/11m.d304a692.jpg";